import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import icubanner from "../../assets/images/icu_banner.png";
import "../nursingcare/NursingCare.css";
import SearchIcon from "@mui/icons-material/Search";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import NursingcareData from "../../LabData/NursingcareData";
// import Longterm from '../nursingcare/Longterm';
import BedsideAttendantLongterm from "./BedsideAttendantLongterm";
import PhysiotherapyServices from "../nursingcare/PhysiotherapyServices";

import { fetchAPI } from "../../utils/api";
import Sidedrawer from "../../components/Sidedrawer";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import EventIcon from "@mui/icons-material/Event";
import Testimonial from "../../layout/Home/Testimonial";
import Review from "../../layout/Home/Review";
import bedsideattendantimg1 from "../../assets/images/bedsideattendant_img_1.png";
import physiotherapistimg2 from "../../assets/images/physiotherapist_img_2.png";
import bedsideattendantbanner from "../../assets/images/bedsideattendant_banner_img.png";
import nursingbanner from "../../assets/images/nursing-banner.png";

const steps = [
  {
    id: 1,
    title: "Book Online",
    desc: "Fill the form or call us",
  },
  {
    id: 2,
    title: "Assessment Call",
    desc: "Doctor reviews patient needs",
  },
  {
    id: 3,
    title: "Equipment Setup",
    desc: "Team arrives with all gear",
  },
  {
    id: 4,
    title: "Care Begins",
    desc: "Nurse starts 24/7 care",
  },
];

export default function BedsideAttendant() {
  const [bedsideData, setBedsideData] = useState(NursingcareData);
  const [expanded, setExpanded] = useState({});
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedShortTerm, setSelectedShortTerm] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const [homeData, setHomeData] = useState({
    testimonials: [],
  });

  useEffect(() => {
    const saved = localStorage.getItem("selectedShortTerm");
    if (saved) {
      try {
        setSelectedShortTerm(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse selectedShortTerm", e);
      }
    }
  }, []);

  const handleCheckboxChange = (service) => {
    setSelectedShortTerm((prev) => {
      const exists = prev.find((item) => item.id === service.id);
      let updated;
      if (exists) {
        updated = prev.filter((item) => item.id !== service.id);
      } else {
        updated = [...prev, service];
      }
      localStorage.setItem("selectedServicesCart", JSON.stringify(updated));
      localStorage.setItem("selectedShortTerm", JSON.stringify(updated));
      localStorage.setItem("activeCartType", "services");
      window.dispatchEvent(new Event("cartUpdated"));
      return updated;
    });
  };

  const filteredBedsideData = bedsideData
    .map((category) => {
      const services = Array.isArray(category.services)
        ? category.services
        : [];
      const matchedServices = services.filter((service) => {
        const serviceName =
          service && typeof service.name === "string" ? service.name : "";
        return serviceName.toLowerCase().includes(searchQuery.toLowerCase());
      });

      const categoryName =
        category && typeof category.servicesname === "string"
          ? category.servicesname
          : "";
      const isCategoryMatch = categoryName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const servicesToKeep = isCategoryMatch ? services : matchedServices;

      if (servicesToKeep.length > 0) {
        return {
          ...category,
          totalservices: ` ${servicesToKeep.length} Service${servicesToKeep.length > 1 ? "s" : ""}`,
          services: servicesToKeep,
        };
      }
      return null;
    })
    .filter(Boolean);

  const [serviceDetail, setServiceDetail] = useState({
    title: "Bedside Attendant",
    subtitle: "Professional bedside assistance at your <span>Doorstep</span>",
    description:
      "All attendants are background-verified, clinically trained, and matched to your patient's specific condition. Select services below to build your care plan.",
    image: bedsideattendantbanner,
  });

  useEffect(() => {
    fetchAPI("CaregiverController/services")
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const service = data.result.find((s) => parseInt(s.service_id) === 3);
          if (service) {
            setServiceDetail({
              title: service.service_title,
              subtitle: service.service_sub_title,
              description: service.service_description,
              image: service.service_image || bedsideattendantbanner,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching service details:", err);
      });
  }, []);

  useEffect(() => {
    fetchAPI("CaregiverController/packages", {
      method: "POST",
      body: JSON.stringify({
        service_id: 3,
        service_type_id: 1,
      }),
    })
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const mapped = data.result.map((cat) => {
            return {
              id: parseInt(cat.package_category_id),
              servicesname: cat.package_category_title,
              totalservices: ` ${cat.packages.length} Service${cat.packages.length > 1 ? "s" : ""}`,
              services: cat.packages.map((pkg) => {
                const priceVal = parseFloat(pkg.price);
                const salePriceVal = parseFloat(pkg.sale_price);
                let offerText = "Special Price";
                if (priceVal > 0 && salePriceVal > 0) {
                  const pct = Math.round(
                    ((priceVal - salePriceVal) / priceVal) * 100,
                  );
                  if (pct > 0) {
                    offerText = `${pct}% Off`;
                  }
                }
                return {
                  id: parseInt(pkg.package_id),
                  name: pkg.package_title,
                  duration: pkg.duration,
                  offer: offerText,
                  price: `₹${pkg.sale_price}`,
                  oldPrice: pkg.price ? `(₹${pkg.price})` : "",
                };
              }),
            };
          });
          setBedsideData(mapped);
        }
      })
      .catch((err) => {
        console.warn(
          "Failed to load short term packages, using static fallback",
          err,
        );
      });
  }, []);

  return (
    <>
      <Header />

      <Sidedrawer
        open={open}
        setOpen={setOpen}
        category={activeCategory}
        selectedServices={selectedShortTerm}
        onServiceToggle={handleCheckboxChange}
      />

      <div className="caregiver_services nurgincare_services">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-6 col-xl-5 col-lg-4 col-md-4 col-12">
              <div className="caregiver_ser_title text-start">
                <h2>
                  <span>{serviceDetail.title}</span> Services at Home
                </h2>
                <p>
                  Receive personalized Bedside Attendant Services at Home with
                  trained attendants offering daily care, mobility assistance,
                  and compassionate support for patients and seniors.
                </p>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-7 col-lg-8 col-md-8 col-12">
              <div className="term-search-outer">
                <div className="search-main-outer">
                  <div className="search_icon_animation">
                    <div className={`search-box ${searchOpen ? "active" : ""}`}>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />

                      <button onClick={() => setSearchOpen(!searchOpen)}>
                        <SearchIcon />
                      </button>
                    </div>
                  </div>
                  <div className="search_sec_long">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <input
                        type="text"
                        placeholder="Search Service...."
                        className="search_input_long"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <button type="button" className="search_btn_long">
                        SEARCH
                      </button>
                    </form>
                  </div>
                </div>

                <div className="tabs_sec_services">
                  <ul
                    className="nav tabs_sec_main nav-pills"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="pills-short-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-short"
                        type="button"
                        role="tab"
                        aria-controls="pills-short"
                        aria-selected="true"
                      >
                        Short Term
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-long-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-long"
                        type="button"
                        role="tab"
                        aria-controls="pills-long"
                        aria-selected="false"
                      >
                        Long Term
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-short"
              role="tabpanel"
              aria-labelledby="pills-short-tab"
              tabindex="0"
            >
              <div className="row">
                <div className="col-lg-12">
                  <div className="caregiver_serv_boxes">
                    <div className="row">
                      {filteredBedsideData.map((nursingcare) => (
                        <div
                          className="col-lg-4 col-md-6 col-12"
                          key={nursingcare.id}
                        >
                          <div className="main_svis_box">
                            <div className="uper_sec_box">
                              <h4>{nursingcare.servicesname}</h4>
                              <p className="btn_sev_box_uper">
                                {nursingcare.totalservices}
                              </p>
                            </div>
                            <div className="lower_sec_box">
                              <div className="services_list_caregiver">
                                <ul className="service_list">
                                  {nursingcare.services
                                    .slice(0, 3)
                                    .map((service) => (
                                      <li
                                        key={service.id}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          if (
                                            !selectedShortTerm.find(
                                              (item) => item.id === service.id,
                                            )
                                          ) {
                                            handleCheckboxChange(service);
                                          }
                                          setActiveCategory(nursingcare);
                                          setOpen(true);
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={`service-${nursingcare.id}-${service.id}`}
                                          checked={
                                            !!selectedShortTerm.find(
                                              (item) => item.id === service.id,
                                            )
                                          }
                                          onChange={(e) => {
                                            e.stopPropagation();
                                            if (
                                              !selectedShortTerm.find(
                                                (item) =>
                                                  item.id === service.id,
                                              )
                                            ) {
                                              handleCheckboxChange(service);
                                            }
                                            setActiveCategory(nursingcare);
                                            setOpen(true);
                                          }}
                                        />

                                        <div className="service_content">
                                          <label
                                            htmlFor={`service-${nursingcare.id}-${service.id}`}
                                            className="service_title"
                                          >
                                            {service.name}
                                          </label>

                                          <div className="service_time">
                                            <small>Duration : </small>
                                            <span>{service.duration}</span>
                                          </div>
                                        </div>

                                        <div className="service_price">
                                          <span className="discount">
                                            {service.offer}
                                          </span>

                                          <div className="price_box price_sec-box">
                                            <span className="current_price">
                                              {service.price}
                                            </span>
                                            <span className="old_price">
                                              {service.oldPrice}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                              <button
                                className="view_all_ser_btn"
                                onClick={() => {
                                  setActiveCategory(nursingcare);
                                  setOpen(true);
                                }}
                              >
                                View All Services
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="col-lg-12">
                        <div className="btn_nursing_care">
                          <Link to="/service-booking">Submit</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ==============long-term===================== */}

            <div
              className="tab-pane fade"
              id="pills-long"
              role="tabpanel"
              aria-labelledby="pills-long-tab"
              tabindex="0"
            >
              {/* <Longterm
                serviceId={3}
                serviceTitle={serviceDetail.title}
                serviceDesc={serviceDetail.description}
                searchQuery={searchQuery}
              /> */}
              <PhysiotherapyServices serviceId={3} searchQuery={searchQuery} />
            </div>
          </div>
        </div>
      </div>

      <section className="whychse caregiver_why_content">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Why Choose Us</span>
              <h2>
                Why Families Trust Our <span>Bedside Attendant</span> Service
              </h2>
              <p>
                Receive dependable Bedside Attendant Services at Home from
                trained caregivers who provide personalized assistance,
                compassionate support, and attentive care throughout the
                recovery journey.
              </p>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Trained & Experienced Attendants</h3>
                <p>
                  Professional bedside attendants trained to assist patients
                  with daily activities while maintaining comfort, dignity, and
                  safety.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <LocalOfferOutlinedIcon />
                <h3>Personalized Care Plans</h3>
                <p>
                  Customized care services based on each patient's health
                  condition, mobility level, and daily support requirements.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Affordable Care Services</h3>
                <p>
                  Quality bedside attendant services with transparent pricing
                  and flexible care plans to suit short-term and long-term
                  needs.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <AddShoppingCartOutlinedIcon />
                <h3>Compassionate Patient Support</h3>
                <p>
                  Dedicated caregivers focused on providing emotional support,
                  personal attention, and continuous assistance for improved
                  well-being.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="icu_content_section">
        <div className="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={bedsideattendantimg1} alt="About" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h2 className="heading-about">
                    What Do <span>Bedside Attendant</span> Services at Home
                    Include?{" "}
                  </h2>
                  <p className="pera-about">
                    Professional Bedside Attendant Services at Home provide
                    essential non-medical support to patients who require
                    assistance with daily living activities. Our trained
                    caregivers help patients maintain comfort, independence, and
                    a better quality of life while recovering safely at home.
                  </p>
                  <p className="pera-about">
                    Our Bedside Attendant in Jaipur services include personal
                    hygiene assistance, bathing, grooming, feeding support,
                    mobility assistance, medication reminders, companionship,
                    toileting assistance, position changing, walking support,
                    and daily routine care.
                  </p>
                  <div className="about_bullet_point">
                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Daily Living Assistance</h4>
                        <p>
                          Our caregivers assist patients with everyday
                          activities while encouraging independence, maintaining
                          dignity, and ensuring a comfortable recovery
                          environment.
                        </p>
                      </div>
                    </div>

                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Continuous Patient Support</h4>
                        <p>
                          Regular monitoring of patient comfort, timely
                          assistance with daily needs, and ongoing communication
                          with family members ensure reliable home care support.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about_us_first_sec nursing_care_c2">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h2 className="heading-about">
                    Benefits of Choosing <span>Bedside Attendant</span> Services
                    at Home
                  </h2>
                  <p className="pera-about">
                    Choosing professional Bedside Attendant Services at Home
                    allows patients to receive compassionate daily care in a
                    familiar environment. It promotes comfort, improves quality
                    of life, reduces caregiver stress, and provides families
                    with confidence that their loved ones are receiving
                    dedicated support.
                  </p>
                  <div className="about_bullet_point">
                    <ul className="bullet_points_care about_point-self">
                      <li>
                        <CheckCircleIcon /> Personalized Daily Care
                      </li>
                      <li>
                        <CheckCircleIcon /> Comfortable Home Recovery
                      </li>
                      <li>
                        <CheckCircleIcon /> Assistance with Daily Activities
                      </li>
                      <li>
                        <CheckCircleIcon /> Improved Patient Safety
                      </li>
                      <li>
                        <CheckCircleIcon /> Emotional Support & Companionship
                      </li>
                      <li>
                        <CheckCircleIcon /> Enhanced Comfort & Dignity
                      </li>
                      <li>
                        <CheckCircleIcon /> Flexible Care Plans
                      </li>
                      <li>
                        <CheckCircleIcon /> Reliable Home Care Support
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={physiotherapistimg2} alt="About" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonial testimonials={homeData.testimonials} />

      <Footer />
    </>
  );
}
